// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Media,
  Container,
  Row,
  Label,
  Form,
  FormGroup,
  Input,
  CardBody,
  Button,
  Badge,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import {
  PreOrder,
  GAME_DETAIL_API,
  VerifyGameId,
  StartTopupPreOrder,
  DeletePreOrder,
  DeleteAllPreOrder,
  SMILEONE_HEALTHZ,
} from "../../services/CONSTANTS";
import {
  getApiDataService,
  postApiDataService,
  deleteApiDataService,
} from "../../services/apiServices";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import {
  ConfirmDialog,
  DataTable,
  FilterBar,
  TablePagination,
} from "components/shared";

import Debounce from "./Util/Debounce";
import { set } from "lodash";
import { bindNiceSelect } from "utils/NiceSelectUtils";
import "../../utils/NiceSelect.css";
import useDebounce from "./Util/Debounce";
import axios from "axios";
import { toast } from "react-toastify";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "orderNo", label: "Order No" },
  { key: "gameAccount", label: "Game Account" },
  { key: "itemName", label: "ItemName" },
  { key: "count", label: "Count" },
  { key: "status", label: "Status" },
  { key: "actions", label: "" },
  { key: "createdAt", label: "Created At" },
  { key: "remark", label: "Remark" },
];

const Preorder = () => {
  const [preorders, setPreorders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [userGameId, setUserGameId] = useState(null);
  const [zoneId, setZoneId] = useState(null);
  const [itemName, setItemName] = useState("");
  const [phone, setPhone] = useState(null);
  const [itemNames, setItemNames] = useState([]);
  const [count, setCount] = useState(1);

  const [total, setTotal] = useState(null);

  const [verifyResult, setVerifyResult] = useState("");

  const [status, setStatus] = useState("pending");
  const [search, setSearch] = useState(null);
  const debounceSearch = useDebounce(search, 1000);

  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteAllModal, setShowDeleteAllModal] = useState(false);
  const [item, setitem] = useState(null);

  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const debounceGameId = useDebounce(userGameId, 1000);
  const debounceZoneId = useDebounce(zoneId, 1000);

  const clearForm = () => {
    setUserGameId("");
    setZoneId("");
    // setItemName("")
    setPhone("");
    setVerifyResult("");
  };
  //   const []
  const [date, setDate] = useState("");

  const [startDate, setStartDate] = useState(
    moment().startOf("day").toISOString()
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").toISOString());

  useEffect(() => {
    if (itemNames.length > 0) {
      const el = document.getElementById("a-select");
      bindNiceSelect(el);
    }
  }, [itemNames]);

  useEffect(() => {
    if (debounceGameId && debounceZoneId) {
      fetchVerifyGameId();
    }
  }, [debounceGameId, debounceZoneId]);

  function debounce(func, delay) {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  }

  useEffect(() => {
    setDate(moment().format("YYYY-MM-DD"));
    fetchPreOrders();
  }, [startDate, endDate, status, debounceSearch, page]);

  useEffect(() => {
    fetGameUnitPrice();
  }, []);

  let fetchPreOrders = () => {
    setIsLoading(true);
    let api =
      PreOrder +
      `?status=${status}&start_date=${startDate}&end_date=${endDate}&perPage=10&page=${page}`;
    api += debounceSearch ? `&search=${debounceSearch}` : "";
    getApiDataService(api)
      .then((res) => {
        console.log("res.data=", res.data);
        if (res?.meta) {
          setTotal(res.meta?.total);
          let totalPages = Number(
            Math.ceil(res.meta?.total / res.meta?.perPage)
          );
          let fromPages = Number(
            res.meta?.perPage * Number(res.meta?.page) -
              Number(res.meta?.perPage)
          );
          setFrom(fromPages + 1);
          setTotalPage(totalPages);
        }
        setPreorders(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setPreorders([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetGameUnitPrice = () => {
    let ml_game_id = null;
    let app_env = process.env.REACT_APP_ENV
    if(app_env=="production"){
      ml_game_id = '649ef8db2f7c0933b90549f8' // prod
    }
    else{
      ml_game_id = "64a47b11c9ff4e256d205815"; // dev
    }

    getApiDataService(GAME_DETAIL_API(ml_game_id))
      .then((res) => {
        let item_prices = filterPriceList(res.data, ["app", "pos"]);
        item_prices = item_prices
        .sort((a, b) => {
          const aHasPlus = a.item_name.includes('+');
          const bHasPlus = b.item_name.includes('+');
          
          if (aHasPlus && !bHasPlus) return -1;
          if (!aHasPlus && bHasPlus) return 1;
          return 0;
        });

        setItemNames(item_prices);
        //   setPaymentAccounts(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        //   setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let fetchVerifyGameId = () => {
    setVerifyResult(null);
    postApiDataService(
      VerifyGameId,
      {
        user_game_id: userGameId,
        zone_id: zoneId,
      },
      false
    )
      .then((res) => {
        let status = res.status;
        console.log("verify", res);
        if (status == 200) {
          setVerifyResult(`${res.username}`);
        } else {
          setVerifyResult("User Not Found!");
        }
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        //   setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  const filterPriceList = (game_data, types) => {
    let price_list = [];
    if (types.includes("app")) {
      price_list = price_list.concat(
        game_data.item_prices?.filter((item) => item.types.includes("app"))
      );
    }
    if (types.includes("pos")) {
      price_list = price_list.concat(
        game_data.item_prices?.filter((item) => item.types.includes("pos"))
      );
      console.log("pos price list", price_list);
    }
    //remove duplicate id
    price_list = price_list.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    );

    //remove duplicate item_name
    price_list = price_list.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.item_name === item.item_name)
    );

    //sort by price_amount
    price_list.sort((a, b) => a.price_amount - b.price_amount);

    return price_list;
  };

  let handleSave = () => {
    let data = {
      user_game_id: userGameId,
      zone_id: zoneId,
      item_name: itemName,
      phone: phone,
      count: count,
      game_user_name: verifyResult,
    };
    console.log(data);
    setBtnLoading(true);
    postApiDataService(PreOrder, data)
      .then((res) => {
        // console.log("res.data=", res.data);
        setBtnLoading(false);
        clearForm();
        fetchPreOrders();
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setBtnLoading(false);
      });
  };

  const handleModalBoxCancel = () => {
    setShowConfirmModal(false);
    setShowDeleteModal(false);
    setShowDeleteAllModal(false);
  };

  const handleDirectTopup = () => {
    console.log("start");
    setIsLoading(true)
    axios
      .get(SMILEONE_HEALTHZ)
      .then((res) => {
        let healthz = res.data?.data;
        if (healthz) {
          postApiDataService(StartTopupPreOrder, null)
            .then((res) => {
              console.log("handleDirectTopup res.data=", res.data);
              setBtnLoading(false);
              fetchPreOrders();
              handleModalBoxCancel();
            })
            .catch((err) => {
              console.log("Error in useEffect!", err);
              setBtnLoading(false);
            });
        } else {
          toast.error("SmileOne Server is DownTime!");
          setBtnLoading(false);
        }
      })
      .catch((err) => {
        console.log("Error in handleDirectTopup!", err);
        setBtnLoading(false);
      });
  };

  const handleDeleteClick = (item) => {
    setitem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DeletePreOrder(item.id))
      .then((res) => {
        console.log("Delete success", res);
        fetchPreOrders();
        handleModalBoxCancel();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
      });
  };

  const handleDeleteAllConfirm = () => {
    setIsLoading(true);
    deleteApiDataService(DeleteAllPreOrder)
      .then((res) => {
        console.log("Delete success", res);
        fetchPreOrders();
        handleModalBoxCancel();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
      });
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col-12">
            <Card className="shadow mb-4">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add Preorder</h3>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <div className="col-12 col-md-6">
                      <FormGroup>
                        <Label for="userGameId">Game ID</Label>
                        <Input
                          type="number"
                          name="userGameId"
                          id="userGameId"
                          value={userGameId}
                          onChange={(e) =>
                            debounce(setUserGameId(e.target.value), 1000)
                          }
                          // onChange={(e) => setUserGameId(e.target.value)}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-12 col-md-6">
                      <FormGroup>
                        <Label for="zoneId">Zone ID</Label>
                        <Input
                          type="number"
                          name="zoneId"
                          id="zoneId"
                          value={zoneId}
                          onChange={(e) =>
                            debounce(setZoneId(e.target.value), 1000)
                          }
                          // onChange={(e) => setZoneId(e.target.value)}
                        />
                        <center className="align-items-center">
                          <h3>
                            {verifyResult == null
                              ? "Checking..."
                              : verifyResult}
                          </h3>
                        </center>
                      </FormGroup>
                    </div>
                  </Row>

                  <Row>
                    <div className="col-12 col-md-6">
                      <FormGroup>
                        <Label for="a-select">Choose Item</Label>
                        <select
                          className="form-control sampleClass"
                          id="a-select"
                          placeholder="Select Item"
                          value={itemName}
                          onChange={(e) => setItemName(e.target.value)}
                        >
                          <option key="0" value={null}>
                            Select
                          </option>
                          {itemNames.map((item, index) => (
                            //<img src={item.payment_provider.logo}></img>
                            <option key={index} value={item.item_name}>
                              {item.item_name}
                            </option>
                            // <option key={index} value={item.id}>{item.types.toString()} - {item.item_name} - {item.id}</option>
                          ))}
                        </select>
                      </FormGroup>
                    </div>
                    <div className="col-12 col-md-6">
                      <FormGroup>
                        <Label for="count">Count</Label>
                        <Input
                          type="number"
                          name="count"
                          id="count"
                          value={count}
                          onChange={(e) => setCount(e.target.value)}
                          // onChange={(e) => setUserGameId(e.target.value)}
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  {/* <FormGroup>
                    <Label for="phone">Phone</Label>
                    <Input
                      type="number"
                      name="phone"
                      id="phone"
                      value={phone}
                      onChange={debounce(
                        (e) => setPhone(e.target.value),
                        1000
                      )}
                    />
                  </FormGroup> */}
                </Form>
              </CardBody>
              <CardFooter className="text-right">
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={
                    btnLoading ||
                    verifyResult == null ||
                    verifyResult == "User Not Found!"
                  }
                >
                  {btnLoading ? "Saving..." : "Save"}
                </button>
              </CardFooter>
            </Card>
          </div>
          <div className="col-12">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar
                  title={
                    <>
                      Pre Order Lists{" "}
                      <Badge color="danger" pill>
                        {total}
                      </Badge>
                    </>
                  }
                >
                  <Input
                    className="w-auto"
                    type="select"
                    //   value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    aria-label="Filter by status"
                  >
                    <option value="pending"> Pending </option>
                    <option value="completed"> Completed </option>
                    <option value="error"> Error </option>
                  </Input>

                  <Input
                    name="orderId"
                    style={{ width: "200px" }}
                    placeholder="Search GameId"
                    aria-label="Search by game ID"
                    type="number"
                    onChange={(e) =>
                      debounce(setSearch(e.target.value), 1000)
                    }
                  />
                  <Button
                    color="primary"
                    onClick={(e) => setShowConfirmModal(true)}
                  >
                    StartTopup
                  </Button>
                  <Button
                    color="danger"
                    onClick={(e) => setShowDeleteAllModal(true)}
                  >
                    Delete All
                  </Button>
                </FilterBar>
              </CardHeader>
              <DataTable
                columns={COLUMNS}
                data={preorders}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(item, index) => (
                  <tr key={item?.id ?? index}>
                    <td>{index + from}</td>
                    <td className="font-mono">{item.order_no}</td>
                    <td>
                      {item.game_user_name} -{" "}
                      <strong>
                        {item.user_game_id} ({item.zone_id})
                      </strong>
                    </td>
                    <td>{item.item_name} </td>
                    <td>{item.count} </td>
                    <td>{item.status} </td>
                    <td>
                      {item.status == "pending" ? (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteClick(item)}
                        >
                          Delete
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>
                      {moment(item.date).format("YYYY-MM-DD hh:mm:ss a")}
                    </td>
                    <td>{item.note}</td>
                  </tr>
                )}
              />
              <TablePagination
                meta={{ total, perPage: 10 }}
                page={page}
                setPage={setPage}
              />
            </Card>
          </div>
        </Row>
      </Container>
      {showConfirmModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Confirm"
          message="Are you sure you want to Topup this orders?"
          confirmText="Yes"
          confirmColor="success"
          isLoading={isLoading}
          onConfirm={handleDirectTopup}
        />
      )}

      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}

      {showDeleteAllModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteAllConfirm}
        />
      )}
    </>
  );
};

export default Preorder;
